// @ts-nocheck
import $ from './dollar';

class ConsumerOptions {
	_elementExists($el: any): any {
		return $el && $el.length === 1;
	}
	_elementOptions($el: any): any {
		return $el.attr('data-options');
	}

	_getConsumerOptions(): {} {
		var options = {},
			$optionElement = $('#ac-iframe-options'),
			$scriptElement = $("script[src*='/atlassian-connect/all']"),
			$cdnScriptElement = $("script[src*='/connect-cdn.atl-paas.net/all']"),
			$fedrampCdnScriptElement = $(
				"script[src*='/connect-alljs-cdn-bifrost.frontend.cdn.atlassian-us-gov-mod.com/assets/all']",
			);

		if (!this._elementExists($optionElement) || !this._elementOptions($optionElement)) {
			if (this._elementExists($scriptElement)) {
				$optionElement = $scriptElement;
			} else if (this._elementExists($cdnScriptElement)) {
				$optionElement = $cdnScriptElement;
			} else if (this._elementExists($fedrampCdnScriptElement)) {
				$optionElement = $fedrampCdnScriptElement;
			}
		}

		if (this._elementExists($optionElement)) {
			// get its data-options attribute, if any
			var optStr = this._elementOptions($optionElement);
			if (optStr) {
				// if found, parse the value into kv pairs following the format of a style element
				optStr.split(';').forEach((nvpair) => {
					nvpair = nvpair.trim();
					if (nvpair) {
						var nv = nvpair.split(':'),
							k = nv[0].trim(),
							v = nv[1].trim();
						if (k && v != null) {
							options[k] = v === 'true' || v === 'false' ? v === 'true' : v;
						}
					}
				});
			}
		}

		return options;
	}

	_flush(): void {
		delete this._options;
	}

	get(key: any): any {
		if (!this._options) {
			this._options = this._getConsumerOptions();
		}
		if (key) {
			return this._options[key];
		}
		return this._options;
	}
}

const _default_1: ConsumerOptions = new ConsumerOptions();
export default _default_1;
